document.addEventListener('DOMContentLoaded', function() {
  var dataEl = document.getElementById('mm-data-sc');
  if (!dataEl) { console.warn('Mix & Match: data element not found'); return; }
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch(e) { console.error('Mix & Match: invalid JSON data', e); return; }
  if (!data.tops || !data.bottoms || !data.tops.length || !data.bottoms.length) {
    console.warn('Mix & Match: no products configured');
    var mmEl = document.getElementById('mix-and-match-sc');
    if (mmEl) mmEl.style.display = 'none';
    return;
  }

  var section = document.getElementById('mix-and-match-sc');
  var modal = document.getElementById('mm-modal-sc');
  var sticky = document.getElementById('mm-sticky-sc');
  var confirmBtn = modal ? modal.querySelector('[data-mm-confirm]') : null;

  var currentPos = section.dataset.currentPos;
  var initialColor = section.dataset.initialColor;
  var ctaText = section.dataset.ctaText || "add set to bag";
  var initTopIdx = parseInt(section.dataset.initTop, 10) || 0;
  var initBottomIdx = parseInt(section.dataset.initBottom, 10) || 0;

  /* ── State ── */
  var pendingLoads = 0; /* event-driven guard: tracks in-flight image loads */
  var isUpdating = function() { return pendingLoads > 0; };
  var state = {
    top: { productIdx: initTopIdx, color: '', preferredColor: '' },
    bottom: { productIdx: initBottomIdx, color: '', preferredColor: '' }
  };

  /* ── Safe scroll helpers (Safari < 15.4 lacks behavior option) ── */
  var supportsScrollBehavior = 'scrollBehavior' in document.documentElement.style;
  function safeScrollTo(el, left, smooth) {
    if (!el) return;
    if (smooth && supportsScrollBehavior) {
      el.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      el.scrollLeft = left;
    }
  }
  function safeScrollBy(el, delta, smooth) {
    if (!el) return;
    if (smooth && supportsScrollBehavior) {
      el.scrollBy({ left: delta, behavior: 'smooth' });
    } else {
      el.scrollLeft += delta;
    }
  }

  /* ── Safe POST helper (fetch with XMLHttpRequest fallback) ── */
  function postJSON(url, body, onSuccess, onError) {
    var jsonStr = JSON.stringify(body);
    if (typeof fetch === 'function') {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: jsonStr
      }).then(function(res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      }).then(onSuccess)['catch'](onError);
    } else {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { onSuccess(JSON.parse(xhr.responseText)); } catch(e) { onSuccess(null); }
        } else { onError(new Error(xhr.status)); }
      };
      xhr.onerror = function() { onError(new Error('network')); };
      xhr.send(jsonStr);
    }
  }

  /* ── Helpers ── */
  function getProduct(pos, idx) {
    var list = data[pos === 'top' ? 'tops' : 'bottoms'];
    if (!list || idx < 0 || idx >= list.length) return null;
    return list[idx];
  }
  function getColors(product) {
    return Object.keys(product.colors);
  }
  function getColorData(product, color) {
    return product.colors[color];
  }
  function firstColor(product) {
    var colors = getColors(product);
    return colors.length ? colors[0] : '';
  }
  function hasAnyFlatlay(product) {
    return getColors(product).some(function(c) { return product.colors[c].hasFlatlay; });
  }
  function hasColorFlatlay(product, color) {
    return product.colors[color] && product.colors[color].hasFlatlay;
  }
  /* ── Garment type detection (auto from aspect ratio, with tag override) ── */
  function getGarmentType(img, product) {
    if (product && product.garmentType) return product.garmentType;
    if (!img || !img.naturalWidth || !img.naturalHeight) return '';
    var ratio = img.naturalWidth / img.naturalHeight;
    if (ratio < 0.55) return 'pants';
    if (ratio < 0.85) return 'cropped';
    return 'shorts';
  }
  /* Normalize URL: strip protocol so absolute and protocol-relative URLs can be compared */
  function normalizeUrl(u) { return u ? u.replace(/^https?:/, '') : ''; }
  function urlsMatch(imgSrc, url) { return url && normalizeUrl(imgSrc) === normalizeUrl(url); }

  function firstFlatlayColor(product) {
    var c = getColors(product).filter(function(c) { return product.colors[c].hasFlatlay; });
    return c[0] || firstColor(product);
  }

  /* ── Shimmer on a single carousel item ── */
  function showItemShimmer(item) {
    if (!item) return;
    var skel = item.querySelector('.mm__carousel-item__skeleton');
    var img = item.querySelector('.mm__carousel-item__img');
    if (skel) skel.classList.add('mm__carousel-item__skeleton--active');
    if (img) img.style.opacity = '0';
    /* Bump generation to invalidate any in-flight preloads */
    item.dataset.mmGen = (parseInt(item.dataset.mmGen || '0', 10) + 1).toString();
  }
  function loadItemImage(item, url, alt, product) {
    if (!item) return;
    var skel = item.querySelector('.mm__carousel-item__skeleton');
    var img = item.querySelector('.mm__carousel-item__img');
    var gen = item.dataset.mmGen || '0';
    if (!url) {
      if (skel) skel.classList.remove('mm__carousel-item__skeleton--active');
      if (img) img.style.opacity = '1';
      pendingLoads = Math.max(0, pendingLoads - 1);
      return;
    }
    pendingLoads++;
    var preload = new Image();
    preload.onload = function() {
      if (item.dataset.mmGen !== gen) { pendingLoads = Math.max(0, pendingLoads - 1); return; }
      if (img) { img.src = url; img.alt = alt || ''; img.style.opacity = '1'; }
      if (skel) skel.classList.remove('mm__carousel-item__skeleton--active');
      /* Update garment type for bottom items */
      if (item.dataset.pos === 'bottom') {
        item.setAttribute('data-garment-type', getGarmentType(preload, product));
      }
      pendingLoads = Math.max(0, pendingLoads - 1);
    };
    preload.onerror = function() {
      if (item.dataset.mmGen !== gen) { pendingLoads = Math.max(0, pendingLoads - 1); return; }
      if (skel) skel.classList.remove('mm__carousel-item__skeleton--active');
      if (img) { img.style.opacity = '0.3'; img.alt = 'Image unavailable'; }
      pendingLoads = Math.max(0, pendingLoads - 1);
    };
    preload.src = url;
  }

  /* ── Build centered carousel with peek ── */
  /* ── Infinite-loop carousel: triple items, reset at edges ── */
  function buildCarousel(pos) {
    var list = pos === 'top' ? data.tops : data.bottoms;
    var container = section.querySelector('[data-mm-carousel="' + pos + '"]');
    if (!container) return;
    container.innerHTML = '';
    var color = state[pos].color;
    var len = list.length;

    /* Build 3 copies for infinite illusion */
    for (var copy = 0; copy < 3; copy++) {
      list.forEach(function(p, i) {
        /* Skip products with no flatlay metafield on any variant */
        if (!hasAnyFlatlay(p)) return;
        var colorData = p.colors[color] || p.colors[firstFlatlayColor(p)];
        if (!colorData || !colorData.flatlay) return;

        var realIdx = i; /* always maps to real product index */
        var item = document.createElement('div');
        var isActive = (copy === 1 && i === state[pos].productIdx);
        item.className = 'mm__carousel-item' + (isActive ? ' mm__carousel-item--active' : '');
        item.dataset.productIdx = realIdx;
        item.dataset.copy = copy;
        item.dataset.pos = pos;

        item.innerHTML =
          '<div class="mm__carousel-item__img-wrap">' +
            '<div class="mm__carousel-item__skeleton"></div>' +
            '<img class="mm__carousel-item__img" src="' + (colorData.flatlay || '') + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' +
          '</div>';

        /* Detect garment type for bottom carousel items */
        if (pos === 'bottom') {
          (function(el, prod) {
            var img = el.querySelector('.mm__carousel-item__img');
            if (img) {
              if (prod.garmentType) {
                el.setAttribute('data-garment-type', prod.garmentType);
              } else {
                img.addEventListener('load', function() {
                  el.setAttribute('data-garment-type', getGarmentType(img, prod));
                }, { once: true });
              }
            }
          })(item, p);
        }

        item.addEventListener('click', function() {
          if (parseInt(item.dataset.productIdx) !== state[pos].productIdx) {
            selectProduct(pos, parseInt(item.dataset.productIdx));
          }
        });

        container.appendChild(item);
      });
    }

    /* Scroll middle copy's active item to center (instant, no animation) */
    requestAnimationFrame(function() { scrollToActive(pos, false); });
  }

  function scrollToActive(pos, smooth) {
    var container = section.querySelector('[data-mm-carousel="' + pos + '"]');
    if (!container) return;
    /* Find the active item in the MIDDLE copy (copy=1) */
    var active = container.querySelector('.mm__carousel-item--active[data-copy="1"]');
    if (!active || !container) return;
    /* Temporarily disable snap for programmatic scroll */
    if (!smooth) container.style.scrollSnapType = 'none';
    var scrollLeft = active.offsetLeft - (container.offsetWidth / 2) + (active.offsetWidth / 2);
    safeScrollTo(container, scrollLeft, smooth);
    if (!smooth) {
      requestAnimationFrame(function() { container.style.scrollSnapType = ''; });
    }
  }

  /* ── Infinite loop: reset to middle copy when scrolled into edge copies ── */
  function bindScrollSnap(pos) {
    var list = pos === 'top' ? data.tops : data.bottoms;
    var container = section.querySelector('[data-mm-carousel="' + pos + '"]');
    if (!container) return;
    var scrollTimer;

    function handleScrollEnd() {
      if (isUpdating()) return;
      var centerX = container.scrollLeft + container.offsetWidth / 2;
      var items = container.querySelectorAll('.mm__carousel-item');
      var closestItem = null;
      var closestDist = Infinity;

      items.forEach(function(item) {
        if (item.style.display === 'none') return;
        var itemCenter = item.offsetLeft + item.offsetWidth / 2;
        var dist = Math.abs(itemCenter - centerX);
        if (dist < closestDist) { closestDist = dist; closestItem = item; }
      });

      if (!closestItem) return;
      var realIdx = parseInt(closestItem.dataset.productIdx);
      var copy = parseInt(closestItem.dataset.copy);

      /* If in edge copy, jump to middle copy */
      if (copy !== 1) {
        var midItem = container.querySelector('[data-copy="1"][data-product-idx="' + realIdx + '"]');
        if (midItem) {
          container.style.scrollSnapType = 'none';
          safeScrollTo(container, midItem.offsetLeft - (container.offsetWidth / 2) + (midItem.offsetWidth / 2), false);
          requestAnimationFrame(function() { container.style.scrollSnapType = ''; });
        }
      }

      if (realIdx !== state[pos].productIdx) {
        selectProduct(pos, realIdx);
      }
    }

    container.addEventListener('scroll', function() {
      if (isUpdating()) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(handleScrollEnd, 250);
    }, { passive: true });

    container.addEventListener('scrollend', function() {
      clearTimeout(scrollTimer);
      handleScrollEnd();
    }, { passive: true });
  }

  /* ── Build color swatches ── */
  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ── Unified color picker: single dropdown controls both top + bottom ── */
  function getAllUnifiedColors() {
    /* Only include colors that have a flatlay in at least one top AND at least one bottom */
    var topColors = {};
    var bottomColors = {};
    data.tops.forEach(function(p) {
      getColors(p).forEach(function(c) {
        if (p.colors[c] && p.colors[c].hasFlatlay) topColors[c] = p.colors[c];
      });
    });
    data.bottoms.forEach(function(p) {
      getColors(p).forEach(function(c) {
        if (p.colors[c] && p.colors[c].hasFlatlay) bottomColors[c] = p.colors[c];
      });
    });
    var colorMap = {};
    Object.keys(topColors).forEach(function(c) {
      if (bottomColors[c]) colorMap[c] = topColors[c];
    });
    return colorMap;
  }

  function buildUnifiedColors() {
    var colorMap = getAllUnifiedColors();
    var colors = Object.keys(colorMap).sort();
    var currentColor = state.top.color; /* single source of truth */

    var container = section.querySelector('[data-mm-colors="unified"]');
    if (!container) return;
    container.innerHTML = '';

    colors.forEach(function(c) {
      var cd = colorMap[c];
      if (!cd) return;
      var isActive = c === currentColor;
      var el = document.createElement('span');
      el.className = 'mm__swatch' + (isActive ? ' mm__swatch--active' : '');
      el.dataset.color = c;
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', c);
      if (cd.swatchImg) el.style.backgroundImage = 'url(' + cd.swatchImg + ')';
      el.style.backgroundColor = cd.swatchBg;
      el.addEventListener('click', function() { selectColor('unified', c); });
      el.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectColor('unified', c); } });
      container.appendChild(el);
    });

    /* Clone to mobile container */
    var mobileContainer = section.querySelector('[data-mm-colors-m="unified"]');
    if (mobileContainer) {
      mobileContainer.innerHTML = '';
      container.querySelectorAll('.mm__swatch').forEach(function(swatch) {
        var clone = swatch.cloneNode(true);
        clone.addEventListener('click', function() { selectColor('unified', clone.dataset.color); });
        clone.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectColor('unified', clone.dataset.color); } });
        mobileContainer.appendChild(clone);
      });
    }

    /* Show/hide swatch arrows + scroll active to center */
    [container, mobileContainer].forEach(function(c) {
      if (!c) return;
      requestAnimationFrame(function() {
        var nav = c.closest('.mm__swatch-nav');
        if (nav) {
          var swatchCount = c.querySelectorAll('.mm__swatch').length;
          var needsArrows = swatchCount > 7;
          nav.querySelectorAll('.mm__swatch-arrow').forEach(function(arrow) {
            arrow.classList.toggle('mm__swatch-arrow--hidden', !needsArrows);
          });
          var isDesktopContainer = !!c.closest('.mm__control-block');
          if (!needsArrows && !isDesktopContainer) {
            c.style.overflow = 'visible';
            c.style.maxWidth = 'none';
            c.style.justifyContent = 'center';
            c.style.padding = '4px 0';
          } else if (!needsArrows && isDesktopContainer) {
            c.style.overflow = 'visible';
          } else {
            c.style.overflow = '';
            c.style.maxWidth = '';
            c.style.justifyContent = '';
            c.style.padding = '';
          }
        }
        var activeEl = c.querySelector('.mm__swatch--active');
        if (activeEl) {
          var cc = c;
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              var cRect = cc.getBoundingClientRect();
              var aRect = activeEl.getBoundingClientRect();
              var cCenter = cRect.left + cRect.width / 2;
              var aCenter = aRect.left + aRect.width / 2;
              var shift = aCenter - cCenter;
              safeScrollBy(cc, shift, true);
            });
          });
        }
      });
    });

    updateUnifiedPill();
  }

  function updateUnifiedPill() {
    var currentColor = state.top.color;
    var colorMap = getAllUnifiedColors();
    var cd = colorMap[currentColor];
    section.querySelectorAll('[data-mm-pill-swatch="unified"]').forEach(function(pillSwatch) {
      if (cd) {
        if (cd.swatchImg) pillSwatch.style.backgroundImage = 'url(' + cd.swatchImg + ')';
        pillSwatch.style.backgroundColor = cd.swatchBg;
      }
    });
    section.querySelectorAll('[data-mm-pill-text="unified"]').forEach(function(pillText) {
      if (cd) pillText.textContent = currentColor.toLowerCase();
    });
  }

  /* ── Hide/show carousel items based on color availability ── */
  function updateCarouselVisibility(pos) {
    var list = pos === 'top' ? data.tops : data.bottoms;
    var color = state[pos].color;
    var container = section.querySelector('[data-mm-carousel="' + pos + '"]');
    if (!container) return;
    var colorCount = 0;
    container.querySelectorAll('.mm__carousel-item').forEach(function(item) {
      var idx = parseInt(item.dataset.productIdx);
      var p = list[idx];
      if (!p) return;
      var hasColor = p.colors[color] && p.colors[color].hasFlatlay;
      item.style.display = hasColor ? '' : 'none';
      if (hasColor && item.dataset.copy === '1') colorCount++;
    });
    /* Also hide/show desktop preview if current product lacks color */
    var previewWrap = section.querySelector('[data-mm-preview="' + pos + '"]');
    if (previewWrap) {
      var curProduct = getProduct(pos, state[pos].productIdx);
      var wrap = previewWrap.closest('.mm__preview-wrap');
      if (curProduct && wrap) {
        var hasColor = curProduct.colors[color] && curProduct.colors[color].hasFlatlay;
        wrap.style.opacity = hasColor ? '' : '0.3';
      }
    }
    /* Hide style arrows when only 1 product has this color */
    var arrows = section.querySelectorAll('[data-mm-arrow="' + pos + '-prev"], [data-mm-arrow="' + pos + '-next"]');
    arrows.forEach(function(a) { a.style.display = colorCount < 2 ? 'none' : ''; });
  }

  /* Legacy buildColors — now a no-op, unified picker handles everything */
  function buildColors(pos) { /* no-op */ }

  /* ── Select product ── */
  /* ── Update product name display ── */
  /* ── ARIA live region announcements ── */
  function announce(msg) {
    var live = section.querySelector('[data-mm-live]');
    if (live) { live.textContent = ''; requestAnimationFrame(function() { live.textContent = msg; }); }
  }

  function updateProductName(pos) {
    var product = getProduct(pos, state[pos].productIdx);
    if (!product) return;

    /* Update all matching elements (desktop + mobile) */
    section.querySelectorAll('[data-mm-product-name="' + pos + '"], [data-mm-product-name-m="' + pos + '"]').forEach(function(el) {
      el.textContent = product.title;
    });
  }

  /* ── Unified shimmer batch: all shimmers stay on until every image in the batch loads ── */
  var shimmerBatchId = 0;
  var shimmerRemaining = 0;
  var shimmerElements = []; /* all .mm__shimmer els participating in current batch */

  function startShimmerBatch() {
    shimmerBatchId++;
    shimmerRemaining = 0;
    shimmerElements = [];
    /* Activate all shimmer overlays immediately */
    section.querySelectorAll('.mm__shimmer').forEach(function(el) {
      el.classList.add('mm__shimmer--active');
      shimmerElements.push(el);
    });
    /* Fade out all images immediately */
    section.querySelectorAll('[data-mm-preview-img], .mmno__peek img').forEach(function(img) {
      img.style.opacity = '0';
    });
    /* Safety: if no images need loading, clear shimmers on next frame */
    var bid = shimmerBatchId;
    requestAnimationFrame(function() {
      if (bid === shimmerBatchId && shimmerRemaining === 0) {
        shimmerElements.forEach(function(el) { el.classList.remove('mm__shimmer--active'); });
        shimmerElements = [];
      }
    });
  }

  function shimmerBatchAdd() { shimmerRemaining++; }

  function shimmerBatchDone(batchId) {
    if (batchId !== shimmerBatchId) return; /* stale batch */
    shimmerRemaining = Math.max(0, shimmerRemaining - 1);
    if (shimmerRemaining === 0) {
      shimmerElements.forEach(function(el) { el.classList.remove('mm__shimmer--active'); });
      shimmerElements = [];
    }
  }

  /* ── Update desktop preview images (with unified shimmer) ── */
  function updatePreview(pos, batchId) {
    var product = getProduct(pos, state[pos].productIdx);
    if (!product) return;
    var colorData = product.colors[state[pos].color];
    var img = section.querySelector('[data-mm-preview-img="' + pos + '"]');
    var container = section.querySelector('[data-mm-preview="' + pos + '"]');
    if (!img || !colorData) return;
    var url = colorData.flatlay || '';
    img.alt = product.title + ' — ' + state[pos].color;
    var useBatch = typeof batchId === 'number';

    /* If url matches current src, no load needed */
    if (urlsMatch(img.src, url)) {
      img.style.opacity = '1';
      return;
    }

    if (!useBatch) {
      /* Solo shimmer (e.g. style arrow nav) */
      var shimmer = container ? container.querySelector('.mm__shimmer') : null;
      if (shimmer) shimmer.classList.add('mm__shimmer--active');
      img.style.opacity = '0';
    }

    if (!url) {
      img.style.opacity = '1';
      if (!useBatch && container) {
        var s = container.querySelector('.mm__shimmer');
        if (s) s.classList.remove('mm__shimmer--active');
      }
      return;
    }

    if (useBatch) shimmerBatchAdd();

    var probe = new Image();
    probe.onload = function() {
      if (pos === 'bottom' && container) {
        container.setAttribute('data-garment-type', getGarmentType(probe, product));
      }
      img.src = url;
      img.style.opacity = '1';
      if (useBatch) shimmerBatchDone(batchId);
      else if (container) { var s = container.querySelector('.mm__shimmer'); if (s) s.classList.remove('mm__shimmer--active'); }
    };
    probe.onerror = function() {
      img.src = url;
      img.style.opacity = '0.3';
      if (useBatch) shimmerBatchDone(batchId);
      else if (container) { var s = container.querySelector('.mm__shimmer'); if (s) s.classList.remove('mm__shimmer--active'); }
    };
    probe.src = url;
  }

  /* ── Update peek images (prev/next style, wrapping circularly) ── */
  function updatePeekImages(pos, batchId) {
    var list = pos === 'top' ? data.tops : data.bottoms;
    var color = state[pos].color;
    /* Filter to products that have a flatlay in the selected color */
    var validIndices = [];
    list.forEach(function(p, i) { if (hasColorFlatlay(p, color)) validIndices.push(i); });

    var prevWrapEl = section.querySelector('[data-mmno-peek="' + pos + '-prev"]');
    var nextWrapEl = section.querySelector('[data-mmno-peek="' + pos + '-next"]');
    if (validIndices.length < 2) {
      /* Hide peeks if only 0–1 styles in this color */
      if (prevWrapEl) prevWrapEl.style.display = 'none';
      if (nextWrapEl) nextWrapEl.style.display = 'none';
      return;
    }
    if (prevWrapEl) prevWrapEl.style.display = '';
    if (nextWrapEl) nextWrapEl.style.display = '';

    var currentIdx = state[pos].productIdx;
    var currentValidPos = validIndices.indexOf(currentIdx);
    if (currentValidPos === -1) currentValidPos = 0;

    var prevIdx = validIndices[(currentValidPos - 1 + validIndices.length) % validIndices.length];
    var nextIdx = validIndices[(currentValidPos + 1) % validIndices.length];

    var prevProduct = list[prevIdx];
    var nextProduct = list[nextIdx];
    var prevUrl = prevProduct.colors[color] ? prevProduct.colors[color].flatlay : '';
    var nextUrl = nextProduct.colors[color] ? nextProduct.colors[color].flatlay : '';

    /* Store indices for click navigation */
    if (prevWrapEl) prevWrapEl.dataset.targetIdx = prevIdx;
    if (nextWrapEl) nextWrapEl.dataset.targetIdx = nextIdx;

    /* Preload peek images with shimmer */
    loadPeekImage(prevWrapEl, prevUrl, prevProduct.title, batchId);
    loadPeekImage(nextWrapEl, nextUrl, nextProduct.title, batchId);
  }

  function loadPeekImage(wrap, url, alt, batchId) {
    if (!wrap) return;
    var img = wrap.querySelector('img');
    if (!img) return;
    var useBatch = typeof batchId === 'number';

    /* If url matches current src, no load needed */
    if (urlsMatch(img.src, url)) {
      img.style.opacity = '1';
      return;
    }

    if (!useBatch) {
      var shimmer = wrap.querySelector('.mm__shimmer');
      if (shimmer) shimmer.classList.add('mm__shimmer--active');
      img.style.opacity = '0';
    }

    if (!url) {
      img.style.opacity = '1';
      if (!useBatch) { var s = wrap.querySelector('.mm__shimmer'); if (s) s.classList.remove('mm__shimmer--active'); }
      return;
    }

    if (useBatch) shimmerBatchAdd();

    var probe = new Image();
    probe.onload = function() {
      img.src = url; img.alt = alt || '';
      img.style.opacity = '1';
      if (useBatch) shimmerBatchDone(batchId);
      else { var s = wrap.querySelector('.mm__shimmer'); if (s) s.classList.remove('mm__shimmer--active'); }
    };
    probe.onerror = function() {
      img.src = url; img.alt = alt || '';
      img.style.opacity = '0.3';
      if (useBatch) shimmerBatchDone(batchId);
      else { var s = wrap.querySelector('.mm__shimmer'); if (s) s.classList.remove('mm__shimmer--active'); }
    };
    probe.src = url;
  }

  function selectProduct(pos, idx) {
    if (state[pos].productIdx === idx) return;
    var product = getProduct(pos, idx);
    if (!product) return;
    state[pos].productIdx = idx;

    /* Keep the unified color — don't change it when switching styles.
       The product may not have this color, which is fine (it'll show as dimmed). */

    /* Update active class across all copies + scroll (if carousel exists) */
    var container = section.querySelector('[data-mm-carousel="' + pos + '"]');
    if (container) {
      container.querySelectorAll('.mm__carousel-item').forEach(function(item) {
        var isMatch = parseInt(item.dataset.productIdx) === idx && item.dataset.copy === '1';
        item.classList.toggle('mm__carousel-item--active', isMatch);
      });
      scrollToActive(pos, true);
    }

    /* Update all item images for current color */
    updateCarouselImages(pos);
    updateProductName(pos);
    updatePreview(pos);
    updatePeekImages(pos);
    updateSticky();

    announce(pos + ': ' + product.title + ', ' + state[pos].color);
  }

  /* ── Select color (unified: always applies to both top + bottom) ── */
  function selectColor(pos, color) {
    if (state.top.color === color && state.bottom.color === color) return;

    /* Apply to both positions */
    state.top.color = color;
    state.top.preferredColor = color;
    state.bottom.color = color;
    state.bottom.preferredColor = color;

    /* Auto-jump to a valid product if current one lacks this color */
    ['top', 'bottom'].forEach(function(p) {
      var list = p === 'top' ? data.tops : data.bottoms;
      var cur = list[state[p].productIdx];
      if (!hasColorFlatlay(cur, color)) {
        for (var i = 0; i < list.length; i++) {
          if (hasColorFlatlay(list[i], color)) {
            state[p].productIdx = i;
            updateProductName(p);
            /* Update carousel active class + scroll */
            var container = section.querySelector('[data-mm-carousel="' + p + '"]');
            if (container) {
              container.querySelectorAll('.mm__carousel-item').forEach(function(item) {
                var isMatch = parseInt(item.dataset.productIdx) === i && item.dataset.copy === '1';
                item.classList.toggle('mm__carousel-item--active', isMatch);
              });
              scrollToActive(p, false);
            }
            break;
          }
        }
      }
    });

    startShimmerBatch();
    var bid = shimmerBatchId;

    buildUnifiedColors();
    updateCarouselImages('top');
    updateCarouselImages('bottom');
    updateCarouselVisibility('top');
    updateCarouselVisibility('bottom');
    updatePreview('top', bid);
    updatePreview('bottom', bid);
    updatePeekImages('top', bid);
    updatePeekImages('bottom', bid);
    updateSticky();

    /* Close swatch row immediately — names reappear */
    var infoBlock = section.querySelector('[data-mmsc-info]');
    if (infoBlock) infoBlock.classList.remove('mmsc__info-block--open');
  }

  /* ── Update all carousel item images for current color (all copies) ── */
  function updateCarouselImages(pos) {
    var list = pos === 'top' ? data.tops : data.bottoms;
    var container = section.querySelector('[data-mm-carousel="' + pos + '"]');
    if (!container) return;
    var items = container.querySelectorAll('.mm__carousel-item');
    var color = state[pos].color;
    items.forEach(function(item) {
      var realIdx = parseInt(item.dataset.productIdx);
      var p = list[realIdx];
      if (!p) return;
      var cd = p.colors[color] || p.colors[firstColor(p)];
      if (cd) {
        showItemShimmer(item);
        loadItemImage(item, cd.flatlay, p.title + ' - ' + (cd ? color : ''), p);
      }
    });
  }

  /* ── Update set price on CTA + sticky ── */
  function getSetPrice() {
    var topProduct = getProduct('top', state.top.productIdx);
    var bottomProduct = getProduct('bottom', state.bottom.productIdx);
    var topColor = topProduct ? getColorData(topProduct, state.top.color) : null;
    var bottomColor = bottomProduct ? getColorData(bottomProduct, state.bottom.color) : null;
    var topPrice = topColor ? topColor.price : 0;
    var bottomPrice = bottomColor ? bottomColor.price : 0;
    var total = topPrice + bottomPrice;
    return '$' + (total / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updatePrices() {
    var formatted = getSetPrice();
    section.querySelectorAll('[data-mm-cta-price]').forEach(function(el) { el.textContent = formatted; });
    var stickyPrice = sticky ? sticky.querySelector('[data-mm-sticky-price]') : null;
    if (stickyPrice) stickyPrice.textContent = formatted;
  }

  /* ── Sticky bar ── */
  function updateSticky() {
    if (!sticky) return;
    var topProduct = getProduct('top', state.top.productIdx);
    var bottomProduct = getProduct('bottom', state.bottom.productIdx);
    if (!topProduct || !bottomProduct) return;
    var topColor = getColorData(topProduct, state.top.color);
    var bottomColor = getColorData(bottomProduct, state.bottom.color);

    var topThumb = sticky.querySelector('[data-mm-sticky-thumb="top"]');
    var bottomThumb = sticky.querySelector('[data-mm-sticky-thumb="bottom"]');
    if (topThumb && topColor) { topThumb.src = topColor.flatlay || ''; topThumb.alt = topProduct.title; }
    if (bottomThumb && bottomColor) { bottomThumb.src = bottomColor.flatlay || ''; bottomThumb.alt = bottomProduct.title; }

    var namesEl = sticky.querySelector('[data-mm-sticky-names]');
    if (namesEl) namesEl.textContent = topProduct.title + ' + ' + bottomProduct.title;

    updatePrices();
  }

  function initStickyObserver() {
    if (!sticky) return;
    var defaultStickyATC = document.getElementById('StickyATC');
    var mmStickyVisible = false;

    function check() {
      var sectionRect = section.getBoundingClientRect();

      /* If section is hidden (e.g. A/B test control), unblock default StickyATC */
      if (!sectionRect.height) {
        if (mmStickyVisible) {
          mmStickyVisible = false;
          sticky.setAttribute('aria-hidden', 'true');
          if (defaultStickyATC) {
            defaultStickyATC.removeAttribute('data-mm-hidden');
            defaultStickyATC.style.transform = '';
          }
        }
        return;
      }

      /* Show M&M sticky whenever section is in/near viewport.
         No early trigger at top (avoids CTS overlap), 20vh linger at bottom. */
      var buffer = window.innerHeight * 0.2;
      var showMmSticky = sectionRect.top < window.innerHeight && sectionRect.bottom > -buffer;

      if (showMmSticky !== mmStickyVisible) {
        mmStickyVisible = showMmSticky;
        sticky.setAttribute('aria-hidden', showMmSticky ? 'false' : 'true');

        /* Coordinate with default StickyATC */
        if (defaultStickyATC) {
          if (showMmSticky) {
            defaultStickyATC.setAttribute('data-mm-hidden', 'true');
            defaultStickyATC.style.transform = 'translateY(100%)';
          } else {
            defaultStickyATC.removeAttribute('data-mm-hidden');
            defaultStickyATC.style.transform = '';
          }
        }
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }

  /* ── Modal ── */
  function buildModalProduct(pos) {
    var product = getProduct(pos, state[pos].productIdx);
    if (!product) return;
    var color = state[pos].color;
    var colorData = getColorData(product, color);
    var el = modal ? modal.querySelector('[data-mm-modal-product="' + pos + '"]') : null;
    if (!el || !colorData) return;

    var img = el.querySelector('.mm__modal-thumb img');
    if (img) { img.src = colorData.flatlay || ''; img.alt = product.title; }

    var name = el.querySelector('.mm__modal-name');
    if (name) name.textContent = product.title;

    var colorEl = el.querySelector('.mm__modal-color');
    if (colorEl) colorEl.textContent = color;

    var fieldset = el.querySelector('.mm__modal-sizes');
    if (!fieldset) return;
    var html = '<legend class="hide">Size for ' + product.title + '</legend>';
    var firstAvail = true;
    colorData.sizes.forEach(function(s) {
      var handle = s.label.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      var checked = s.avail && firstAvail ? ' checked' : '';
      if (s.avail && firstAvail) firstAvail = false;
      var disabled = s.avail ? '' : ' disabled';
      var cls = s.avail ? '' : ' class="mm__sold-out"';
      html += '<div class="mm__modal-size">' +
        '<input type="radio" name="mm-sc-size-' + pos + '" id="mm-sc-s-' + pos + '-' + handle + '" value="' + s.id + '"' + checked + disabled + '>' +
        '<label for="mm-sc-s-' + pos + '-' + handle + '"' + cls + '>' + s.label + '</label></div>';
    });
    fieldset.innerHTML = html;
    fieldset.querySelectorAll('input[type="radio"]').forEach(function(r) {
      r.addEventListener('change', checkModalSelections);
    });
  }

  var lastFocusBeforeModal = null;
  var savedScrollY = 0;
  function lockBodyScroll() {
    savedScrollY = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }
  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }
  function openModal() {
    if (!modal) return;
    lastFocusBeforeModal = document.activeElement;
    buildModalProduct('top');
    buildModalProduct('bottom');
    checkModalSelections();
    modal.style.display = 'flex';
    lockBodyScroll();
    /* Focus first interactive element */
    var first = modal.querySelector('input:not(:disabled), button');
    if (first) first.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.style.display = 'none';
    unlockBodyScroll();
    if (lastFocusBeforeModal) lastFocusBeforeModal.focus();
  }

  function checkModalSelections() {
    if (!confirmBtn) return;
    var s1 = modal.querySelector('input[name="mm-sc-size-top"]:checked:not(:disabled)');
    var s2 = modal.querySelector('input[name="mm-sc-size-bottom"]:checked:not(:disabled)');
    confirmBtn.disabled = !(s1 && s2);
  }

  /* ── Add to cart ── */
  var isAdding = false;
  function addToCart() {
    if (isAdding) return;
    var s1 = modal ? modal.querySelector('input[name="mm-sc-size-top"]:checked') : null;
    var s2 = modal ? modal.querySelector('input[name="mm-sc-size-bottom"]:checked') : null;
    if (!s1 || !s2) return;

    isAdding = true;
    if (confirmBtn) { confirmBtn.disabled = true; confirmBtn.textContent = 'adding to bag...'; }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    postJSON(root + 'cart/add.js', {
      items: [
        { id: parseInt(s1.value, 10), quantity: 1 },
        { id: parseInt(s2.value, 10), quantity: 1 }
      ]
    }, function() {
      if (confirmBtn) confirmBtn.textContent = 'added!';
      setTimeout(function() {
        isAdding = false;
        closeModal();
        if (confirmBtn) { confirmBtn.textContent = ctaText; confirmBtn.disabled = false; }
        var cartLink = document.querySelector('.js-drawer-open-cart');
        if (cartLink) cartLink.click();
      }, 500);
    }, function() {
      isAdding = false;
      if (confirmBtn) { confirmBtn.textContent = 'error - try again'; confirmBtn.disabled = false; }
      setTimeout(function() { if (confirmBtn) { confirmBtn.textContent = ctaText; } checkModalSelections(); }, 3000);
    });
  }

  /* ── Arrow navigation ── */
  function arrowNav(pos, direction) {
    var list = pos === 'top' ? data.tops : data.bottoms;
    var len = list.length;
    var currentIdx = state[pos].productIdx;

    /* Go to next/prev style, only visiting products with a flatlay in the selected color */
    var color = state[pos].color;
    var step = direction === 'next' ? 1 : -1;
    var newIdx = currentIdx;
    var found = false;
    for (var i = 0; i < len; i++) {
      newIdx = (newIdx + step + len) % len;
      if (hasColorFlatlay(list[newIdx], color)) { found = true; break; }
    }
    if (found && newIdx !== currentIdx) {
      /* Disable snap during programmatic scroll, re-enable after */
      var container = section.querySelector('[data-mm-carousel="' + pos + '"]');
      if (container) {
        container.style.scrollSnapType = 'none';
        setTimeout(function() { container.style.scrollSnapType = ''; }, 500);
      }
      selectProduct(pos, newIdx);
    }
  }

  /* ── Color pill toggle: show/hide swatch row, hide/show names ── */
  var infoBlock = section.querySelector('[data-mmsc-info]');
  section.querySelectorAll('[data-mmsc-pill]').forEach(function(pill) {
    pill.addEventListener('click', function(e) {
      e.preventDefault();
      if (infoBlock) infoBlock.classList.toggle('mmsc__info-block--open');
    });
  });

  /* ── Update pill swatch + text — legacy per-pos is no-op, unified handled by updateUnifiedPill ── */
  function updatePill(pos) { /* no-op — unified pill updated via buildUnifiedColors */ }

  /* Bind swatch scroll arrows */
  section.querySelectorAll('.mm__swatch-arrow').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var key = btn.dataset.mmSwatchArrow; /* e.g. "top-next" */
      var pos = key.split('-')[0];
      var dir = key.split('-')[1];
      var colorsEl = btn.closest('.mm__swatch-nav').querySelector('.mm__colors');
      if (colorsEl) {
        var scrollAmount = dir === 'next' ? 120 : -120;
        safeScrollBy(colorsEl, scrollAmount, true);
      }
    });
  });

  /* Bind all arrow buttons (carousel arrows + inline desktop arrows) */
  section.querySelectorAll('.mm__arrow, .mm__arrow-inline, .mm__preview-arrow').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var key = btn.dataset.mmArrow;
      var parts = key.split('-');
      arrowNav(parts[0], parts[1]);
    });
  });

  /* ── Peek click handlers: click prev/next peek to navigate ── */
  section.querySelectorAll('.mmno__peek').forEach(function(peek) {
    peek.addEventListener('click', function() {
      var key = peek.dataset.mmnoPeek; /* e.g. "top-prev" or "bottom-next" */
      var pos = key.split('-')[0];
      var targetIdx = parseInt(peek.dataset.targetIdx);
      if (!isNaN(targetIdx)) selectProduct(pos, targetIdx);
    });
  });

  /* ── Event Bindings ── */
  document.querySelectorAll('[data-mm-open-modal]').forEach(function(btn) {
    btn.addEventListener('click', function(e) { e.preventDefault(); openModal(); });
  });
  if (modal) {
    modal.querySelectorAll('[data-mm-close]').forEach(function(el) {
      el.addEventListener('click', closeModal);
    });
  }
  document.addEventListener('keydown', function(e) {
    var modalOpen = modal && modal.style.display !== 'none';

    if (e.key === 'Escape' && modalOpen) closeModal();

    /* Focus trap inside modal */
    if (e.key === 'Tab' && modalOpen) {
      var focusable = modal.querySelectorAll('button:not(:disabled), input:not(:disabled), [tabindex]:not([tabindex="-1"])');
      if (focusable.length) {
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    /* Keyboard arrow navigation for carousels (when section is in view) */
    if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !modalOpen) {
      var mmRect = section.getBoundingClientRect();
      if (mmRect.top < window.innerHeight && mmRect.bottom > 0) {
        var dir = e.key === 'ArrowRight' ? 'next' : 'prev';
        arrowNav('top', dir);
        e.preventDefault();
      }
    }
  });
  if (confirmBtn) {
    confirmBtn.addEventListener('click', addToCart);
  }

  /* ── PDP → M&M sync (one-way) ── */
  document.querySelectorAll('[data-handle="color"] input[data-variant-input]').forEach(function(input) {
    input.addEventListener('change', function() {
      if (!input.hasAttribute('data-sticky-clone')) {
        var newColor = this.value;
        var colorMap = getAllUnifiedColors();
        if (colorMap[newColor] && state.top.color !== newColor) {
          selectColor('unified', newColor);
        }
      }
    });
  });

  /* ── Init ── */
  (function init() {
    /* Set initial color — single unified color for both positions */
    var topProduct = getProduct('top', state.top.productIdx);
    if (!topProduct) {
      console.warn('Mix & Match: top product not found at index', state.top.productIdx);
      section.style.display = 'none';
      return;
    }

    if (initialColor) {
      var colorMap = getAllUnifiedColors();
      if (colorMap[initialColor]) {
        state.top.color = initialColor;
      } else {
        state.top.color = firstFlatlayColor(topProduct);
      }
    } else {
      state.top.color = firstFlatlayColor(topProduct);
    }
    state.top.preferredColor = state.top.color;
    state.bottom.color = state.top.color;
    state.bottom.preferredColor = state.top.color;

    buildCarousel('top');
    buildCarousel('bottom');
    bindScrollSnap('top');
    bindScrollSnap('bottom');
    buildUnifiedColors();
    updateCarouselVisibility('top');
    updateCarouselVisibility('bottom');
    updateProductName('top');
    updateProductName('bottom');
    updatePreview('top');
    updatePreview('bottom');
    updatePeekImages('top');
    updatePeekImages('bottom');
    updateSticky();
    initStickyObserver();
  })();
});
